import { ReactNode } from 'react'

import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'

export interface SidebarContentProps {
  children: ReactNode
  title?: string
  description?: string
  header?: ReactNode
}

export const SidebarContent = ({
  children,
  header,
  title,
  description,
}: SidebarContentProps) => {
  return (
    <div className="space-y-4">
      {header}
      <div className="space-y-4 px-3">
        <SectionHeader title={title} description={description} />
        {children}
      </div>
    </div>
  )
}
